import React from 'react'
import styles from './TemplateMsgItem.module.css'
import { useTranslation } from "react-i18next";

const TemplateMsgItem = (props) => {
    const [t] = useTranslation('common')
    const getTemplateIconElement = (templateType) => {
        switch (templateType) {
            case 'image': return <i title={t('image')} className={`fa-regular fa-file-image fa-xl ${styles['template-icon']}`} />
            case 'video': return <i title={t('video')} className={`fa-regular fa-file-video fa-xl ${styles['template-icon']}`} />
            case 'document': return <i title={t('document')} className={`fa-regular fa-file fa-xl ${styles['template-icon']}`} />
            default:
                return <i title={t('text')} className={`fa-regular fa-pen-to-square fa-lg ${styles['template-icon']}`} />
        }
    }

    const tempMsg = props.tempMsg
    const templateMessageClickHandler = props.templateMessageClickHandler

    let templateIconElement = getTemplateIconElement(tempMsg.templateType)

    const originalCategory = tempMsg?.category;
    const category = t(originalCategory);

    const formattedCategory = originalCategory === "MARKETING" ? `${category}\u00A0\u00A0-\u00A0`: `${category}\u00A0-\u00A0`;
    const whatsappVerifiedIndicator = tempMsg?.whatsappVerified ? formattedCategory : null;

    return (
        <p className={`${styles['templateItem']}`} key={tempMsg._id} onClick={() => templateMessageClickHandler(tempMsg)}>
            {templateIconElement}
            <span className={styles['category-translation']}>
                {whatsappVerifiedIndicator}
            </span>
            {tempMsg.msg}
        </p>
    );
}

export default TemplateMsgItem